"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntl = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
Object.defineProperty(exports, "useIntl", { enumerable: true, get: function () { return react_intl_1.useIntl; } });
function useFormatMessage() {
    const intl = (0, react_intl_1.useIntl)();
    return (0, react_1.useCallback)(function format(id, values) {
        if (!id || !intl.messages[id]) {
            return id || '';
        }
        return intl.formatMessage({ id }, { ...values });
    }, [intl]);
}
exports.default = useFormatMessage;
